import { DragDropModule } from '@angular/cdk/drag-drop'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatChipsModule } from '@angular/material/chips'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { TranslateModule } from '@ngx-translate/core'

import { TimeSlotPickerComponent, TimeSlotPickerCustomComponent, TimeSlotPickerRowComponent, TimeSlotRecommendationComponent } from './components'
import { TimeSlotPickerService } from './services'

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FlexLayoutModule,
    MatIconModule,
    MatChipsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
    TranslateModule,
  ],
  exports: [
    TimeSlotPickerComponent,
  ],
  declarations: [
    TimeSlotPickerComponent,
    TimeSlotPickerRowComponent,
    TimeSlotRecommendationComponent,
    TimeSlotPickerCustomComponent,
  ],
  providers: [
    TimeSlotPickerService,
  ],
})
export class TimeSlotPickerModule { }
